'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FreightTimeController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _freightTime = require('./freightTime.routes');

var _freightTime2 = _interopRequireDefault(_freightTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FreightTimeController = exports.FreightTimeController = function () {

  /*@ngInject*/
  function FreightTimeController($http, FreightTime) {
    _classCallCheck(this, FreightTimeController);

    this.awesomeThings = [];
    this.newThing = '';
    this.stops = ['Kismet', 'Saltaire', 'Fair Harbor', 'Dunewood', 'Atlantique', 'Ocean Beach', 'Seaview', 'Ocean Bay Park'];

    this.$http = $http;
    this.$FreightTime = FreightTime;
  }

  _createClass(FreightTimeController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$FreightTime.query().then(function (response) {
        if (response && response.length > 0) {
          _this.times = response[0];
        } else {
          _this.times = {
            createdAt: null,
            updatedAt: null,
            oceanBeach: null,
            fairHarbor: null,
            kismet: null,
            seaview: null,
            saltaire: null,
            dunewood: null,
            atlantique: null,
            oceanBayPark: null
          };
        }
      });
    }
  }, {
    key: 'save',
    value: function save(times) {
      var _this2 = this;

      if (times) {
        if (times._id) {
          Reflect.deleteProperty(times, '_id');
          Reflect.deleteProperty(times, 'createdAt');
          Reflect.deleteProperty(times, 'updatedAt');
        }
        this.$FreightTime.save(times).then(function (response) {
          console.log(response);
          _this2.times = response;
        });
      }
    }
  }]);

  return FreightTimeController;
}();

exports.default = _angular2.default.module('fiapiApp.freightTime', [_angularUiRouter2.default]).config(_freightTime2.default).component('freightTime', {
  template: require('./freightTime.pug'),
  controller: FreightTimeController,
  controllerAs: '$freightTime',
  authenticate: true
}).name;


// WEBPACK FOOTER //
// ./client/app/freightTime/freightTime.component.js